import { render, staticRenderFns } from "./ExamHistory.vue?vue&type=template&id=a981f18e&scoped=true"
import script from "./ExamHistory.vue?vue&type=script&lang=js"
export * from "./ExamHistory.vue?vue&type=script&lang=js"
import style0 from "./ExamHistory.vue?vue&type=style&index=0&id=a981f18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a981f18e",
  null
  
)

export default component.exports